// extracted by mini-css-extract-plugin
module.exports = {"image-asset":"ImageAsset_image-asset__1X-cd"};